__turbopack_context__.v({
  "container": "_8p-J4q_container",
  "dieselLogo": "_8p-J4q_dieselLogo",
  "divider": "_8p-J4q_divider",
  "logoWrapper": "_8p-J4q_logoWrapper",
  "section": "_8p-J4q_section",
  "uhLogo": "_8p-J4q_uhLogo",
});
